import React, { useState } from "react";
import { Button, Flex, List, Typography, Upload, Image, Spin } from "antd";
import { BankOutlined, UploadOutlined } from "@ant-design/icons";
import type { RcFile, UploadFile, UploadProps } from "antd/es/upload/interface";
import { t } from "i18next";
import { message } from "antd";

type Props = {
  user?: string;
};

const { Paragraph, Text } = Typography;

export const OrderInvoiced = ({ user = "asd" }: Props) => {
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [pointOfSaleStr, setPointOfSaleStr] = useState("0001");
  const [numberStr, setNumberStr] = useState("0000235987");

  const handleUpload: UploadProps["customRequest"] = ({ file, onSuccess }) => {
    const fileObject = file as RcFile;
    setTimeout(() => {
      setFileList([
        {
          uid: fileObject.uid,
          name: fileObject.name,
          url: URL.createObjectURL(fileObject),
        },
      ]);
      if (onSuccess) {
        onSuccess("ok");
      }
    }, 1000);
  };

  const handleBeforeUpload = (file: RcFile) => {
    const limitMB = 15;
    const isLessThanLimit = file.size / 1024 / 1024 < limitMB;
    if (!isLessThanLimit) {
      message.error(
        `El archivo "${file.name}" excede el tamaño máximo permitido de ${limitMB}MB`,
      );
    }
    return isLessThanLimit ? true : Upload.LIST_IGNORE;
  };

  return (
    <Spin spinning={false} tip="Generating invoice">
      <List className="summary-list" itemLayout="vertical" size="large">
        <List.Item>
          <Flex gap={24}>
            <Flex vertical>
              <Text strong type="secondary">
                {t("contacts.title.invoicetype")}
              </Text>
              <Text>Factura A</Text>
            </Flex>

            <Flex vertical>
              <Text strong type="secondary">
                {t("contacts.registeredName")}
              </Text>
              <Text>Empresa SA. 30709520209</Text>
            </Flex>

            <Flex vertical>
              <Text strong type="secondary">
                {t("orders.PointFfSale")}
              </Text>
              <Paragraph
                editable={{
                  onChange: setPointOfSaleStr,
                  triggerType: ["text", "icon"],
                }}
              >
                {pointOfSaleStr}
              </Paragraph>
            </Flex>

            <Flex vertical>
              <Text strong type="secondary">
                N°
              </Text>
              <Paragraph
                editable={{
                  onChange: setNumberStr,
                  triggerType: ["text", "icon"],
                }}
              >
                {numberStr}
              </Paragraph>
            </Flex>

            <Flex style={{ flexGrow: 2 }} vertical gap={8}>
              <Text strong type="secondary">
                {t("orders.label.paymentreceipt")}
              </Text>
              <Flex>
                {fileList.length > 0 && (
                  <Image
                    width={100}
                    src={fileList[0].url}
                    alt="Uploaded preview"
                    style={{
                      borderRadius: 8,
                      border: "1px solid #ddd",
                      padding: 3,
                    }}
                  />
                )}
              </Flex>
            </Flex>
          </Flex>
          <Flex justify="space-between" style={{ marginTop: 24 }}>
            <Button danger>{t("orders.cancelOrder")}</Button>

            <Flex gap={10}>
              <Upload
                customRequest={handleUpload}
                beforeUpload={handleBeforeUpload}
                listType="picture"
                accept="png, jpg, pdf"
                maxCount={1}
                showUploadList={false}
              >
                <Button iconPosition="end" icon={<UploadOutlined />}>
                  {t("buttons.upload")}
                </Button>
              </Upload>
            </Flex>
          </Flex>
        </List.Item>
      </List>
    </Spin>
  );
};
